
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import Row from '../layout/Row';
import { SCREEN_WIDTH } from '../stateProvider/StateProvider';
import Col from '../layout/Col';
import { between } from '../utility/functions';

const Cell = styled.td`
    all: unset;
    position: relative;
    overflow: hidden;
    padding: unset !important;
`

const Expander = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5em;
    position: absolute;
    top: -1.2em;
    margin: 0 1em 0 0;
`

const ManagementRow = ({ controls, children, ...props }) => {
    const rowRef = useRef(null)
    const mRef = useRef(null)

    const enabled = true;
    const [show, setShow] = useState(false);
    const [mousePos, setMousePos] = useState(null);
    const [leftOf, setLeftOf] = useState(20);
    const [transition, setTransition] = useState(false);

    const handleMouseMove = (e) => {
        const boundingRect = rowRef.current.getBoundingClientRect();
        const mouseX = (e.clientX - boundingRect.left) / (boundingRect.width * 0.69);
        setMousePos(mouseX);

        if (!mRef.current) return
        const mBoundingRect = mRef.current.getBoundingClientRect();
        setLeftOf(show ? between((mousePos * mBoundingRect.width) * 1.1, 0, mBoundingRect.width + 30) * -1 : 20)
    }

    useEffect(() => {
        if (transition) {
            setTimeout(() => setTransition(false), 150)
        }
    }, [transition])

    return (
        <tr
            ref={rowRef}
            onMouseEnter={() => {
                setTransition(true)
                setShow(true)
            }}
            onMouseLeave={() => {
                setTransition(true)
                setShow(false)
                setMousePos(null)
                setLeftOf(20)
            }}
            onMouseMove={handleMouseMove}
            {...props}
        >
            {children}
            <Cell>
                {SCREEN_WIDTH ? <Row>{controls}</Row> : enabled ? (
                    <Expander
                        ref={mRef}
                        style={{
                            left: `${leftOf}px`,
                            transition: transition ? 'all 0.15s' : '',
                        }}
                    >
                        {controls}
                    </Expander>
                ) : <Col>{controls}</Col>}
            </Cell>
        </tr>
    )
}

export default ManagementRow;
